<template>
  <SliderGroup
    v-if="chips.length"
    :items="chips"
    :fog="!isMobile"
    :padding-x="isMobile ? 8 : undefined"
    :class="isMobile ? 'mx-n2' : undefined"
    no-auto-position
  >
    <template #default="{ item, onClick }">
      <MenuChip
        v-if="item.menuChip"
        :item="{ ...item, name: t(item.name, options) }"
        :on-click="onClick"
      />
      <MapChip
        v-else-if="item.mapChip"
      />
      <DefaultChip
        v-else
        :item="{ ...item, name: t(item.name, options) }"
        :on-click="onClick"
      />
    </template>
  </SliderGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import sortChipsFilters from 'www/vue_components/common/TheFilters/lpu/functions/sortChipsFilters'
import SliderGroup from 'www/vue_components/common/SliderGroup/SliderGroup.vue'
import MapChip from 'www/vue_components/common/TheFilters/lpu/components/ChipsFilters/MapChip.vue'
import MenuChip from 'www/vue_components/common/TheFilters/lpu/components/ChipsFilters/MenuChip.vue'
import DefaultChip from 'www/vue_components/common/TheFilters/lpu/components/ChipsFilters/DefaultChip.vue'
import type { IChip } from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore.types'

const { t, language } = I18NextVue
const options = { ns: language }

const chipsStore = useChipsStore()
const isMobile = window.MOBILE_VERSION

const chips = computed<IChip[]>(() => [
  chipsStore.menuChip,
  chipsStore.placeChip,
  chipsStore.lpuTypeChip,
  chipsStore.workTimeChip,
  chipsStore.clubSwitchChip,
  chipsStore.highRatingChip,
  chipsStore.appointmentChip,
  chipsStore.doctorSpecialityChip,
  chipsStore.mapChip,
]
  .filter((chip): chip is IChip => Boolean(chip && chip.isVisible))
  .sort(sortChipsFilters))
</script>
